export var ChannelState;
(function (ChannelState) {
  ChannelState.INITIAL = 'INITIAL';
  ChannelState.CANCELLED = 'CANCELLED';
  ChannelState.UNDER_REVIEW = 'UNDER_REVIEW';
  ChannelState.DEMONETIZED = 'DEMONETIZED';
  ChannelState.ACCEPTED = 'ACCEPTED';
  ChannelState.CUSTOMER = 'CUSTOMER';
  ChannelState.FOR_FUTURE = 'FOR_FUTURE';
  ChannelState.ICE_BOX = 'ICE_BOX';
  ChannelState.REMOVED = 'REMOVED';
}(ChannelState || (ChannelState = {})));
